import cx from 'classnames'
import { type ReactNode, useState } from 'react'

import CheckmarkIcon from './checkmark-icon'

export interface CheckboxInputProps {
  name: string
  label: string | ReactNode
  value?: string
  checked?: boolean
  onChange?: (checked: boolean) => void
  className?: string
}

const CheckboxInput = ({
  name,
  label,
  value,
  checked = false,
  onChange = () => ({}),
  className,
}: CheckboxInputProps) => {
  const [isCheckedInnerState, setIsCheckedInnerState] = useState(checked)

  return (
    <label
      className={cx('relative flex items-center cursor-pointer', className)}
    >
      <input
        type="checkbox"
        name={name}
        value={value}
        defaultChecked={checked}
        onChange={(event) => {
          onChange(event.target.checked)
          setIsCheckedInnerState(event.target.checked)
        }}
        className="absolute opacity-0 pointer-events-none"
      />

      <div
        className={cx(
          'flex-none flex justify-center items-center w-[18px] h-[18px] border rounded-sm',
          {
            'border-btn-filled-border bg-btn-filled-bg': isCheckedInnerState,
            'border-gray-400 bg-transparent': !isCheckedInnerState,
          },
        )}
      >
        <CheckmarkIcon
          className={cx('h-3 text-white', {
            hidden: !isCheckedInnerState,
            block: isCheckedInnerState,
          })}
        />
      </div>

      <span className="ml-3">{label}</span>
    </label>
  )
}

export default CheckboxInput
